"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _FieldDisplay = _interopRequireDefault(require("./FieldDisplay"));
var _FormCheckboxField = _interopRequireDefault(require("./FormCheckboxField"));
var _FormDateField = _interopRequireDefault(require("./FormDateField"));
var _FormDurationField = _interopRequireDefault(require("./FormDurationField"));
var _FormInputField = _interopRequireDefault(require("./FormInputField"));
var _FormRadioField = _interopRequireDefault(require("./FormRadioField"));
var _FormSelectField = _interopRequireDefault(require("./FormSelectField"));
var _FormTextareaField = _interopRequireDefault(require("./FormTextareaField"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var field = function field(type, props) {
  switch (type) {
    case 'select':
      return /*#__PURE__*/_react["default"].createElement(_FormSelectField["default"], props);
    case 'checkbox':
      return /*#__PURE__*/_react["default"].createElement(_FormCheckboxField["default"], props);
    case 'radio':
      return /*#__PURE__*/_react["default"].createElement(_FormRadioField["default"], props);
    case 'textarea':
      return /*#__PURE__*/_react["default"].createElement(_FormTextareaField["default"], props);
    case 'date':
      return /*#__PURE__*/_react["default"].createElement(_FormDateField["default"], props);
    case 'duration':
      return /*#__PURE__*/_react["default"].createElement(_FormDurationField["default"], props);
    case 'block':
      return /*#__PURE__*/_react["default"].createElement(_FieldDisplay["default"], props);
    default:
      return /*#__PURE__*/_react["default"].createElement(_FormInputField["default"], props);
  }
};
var FormField = function FormField(props) {
  var question = props.question,
    hiddenFields = props.hiddenFields,
    section = props.section;
  if ((0, _lodash.indexOf)(hiddenFields, question.id) >= 0) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-form-renderer-question"
  }, field(question.input_type, {
    question: question,
    section: section
  }));
};
FormField.propTypes = {
  question: _propTypes["default"].shape({
    id: _propTypes["default"].string,
    input_type: _propTypes["default"].string
  }).isRequired,
  hiddenFields: _propTypes["default"].array.isRequired,
  section: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = FormField;